import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_CARE_AND_USE_REQUEST,
  CREATE_CARE_AND_USE_SUCCESS,
  CREATE_CARE_AND_USE_FAILURE,
  GET_ALL_CARE_AND_USE_REQUEST,
  GET_ALL_CARE_AND_USE_SUCCESS,
  GET_ALL_CARE_AND_USE_FAILURE,
  GET_ONE_CARE_AND_USE_REQUEST,
  GET_ONE_CARE_AND_USE_SUCCESS,
  GET_ONE_CARE_AND_USE_FAILURE,
  EDIT_CARE_AND_USE_REQUEST,
  EDIT_CARE_AND_USE_SUCCESS,
  EDIT_CARE_AND_USE_FAILURE,
  DELETE_CARE_AND_USE_REQUEST,
  DELETE_CARE_AND_USE_SUCCESS,
  DELETE_CARE_AND_USE_FAILURE,
  UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_REQUEST,
  UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_SUCCESS,
  UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_FAILURE,


} from "./CareInstructionsTypes"; 

let baseUrl = Config.baseUrl;

// --- CREATE API ---
const createCareAndUseRequest = () => ({
  type: CREATE_CARE_AND_USE_REQUEST,
});
const createCareAndUseSuccess = (payload) => ({
  type: CREATE_CARE_AND_USE_SUCCESS,
  payload,
});
const createCareAndUseFailure = (error) => ({
  type: CREATE_CARE_AND_USE_FAILURE,
  payload: error,
});

const createCareAndUseInstructions = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createCareAndUseRequest());
    let url = `${baseUrl}/dpp/care_and_use_instructions/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createCareAndUseSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createCareAndUseFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- GET ALL API ---
const getAllCareAndUseRequest = () => ({
  type: GET_ALL_CARE_AND_USE_REQUEST,
});
const getAllCareAndUseSuccess = (payload) => ({
  type: GET_ALL_CARE_AND_USE_SUCCESS,
  payload,
});
const getAllCareAndUseFailure = (error) => ({
  type: GET_ALL_CARE_AND_USE_FAILURE,
  payload: error,
});

const getAllCareAndUseInstructions = (jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getAllCareAndUseRequest());
    let url = `${baseUrl}/dpp/care_and_use_instructions/get`;
    // let url = `http://editor-dev.mobillor.net:1880/api/acp/api/swms/dpp/care_and_use_instructions/get`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAllCareAndUseSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAllCareAndUseFailure(err.message));
      });
  };
};

// --- GET ONE API ---
const getOneCareAndUseRequest = () => ({
  type: GET_ONE_CARE_AND_USE_REQUEST,
});
const getOneCareAndUseSuccess = (payload) => ({
  type: GET_ONE_CARE_AND_USE_SUCCESS,
  payload,
});
const getOneCareAndUseFailure = (error) => ({
  type: GET_ONE_CARE_AND_USE_FAILURE,
  payload: error,
});

const getOneCareAndUseInstruction = (careId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getOneCareAndUseRequest());
    let url = `${baseUrl}/dpp/care_and_use_instructions/get_one?careId=${careId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOneCareAndUseSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOneCareAndUseFailure(err.message));
      });
  };
};

// --- EDIT API ---
const editCareAndUseRequest = () => ({
  type: EDIT_CARE_AND_USE_REQUEST,
});
const editCareAndUseSuccess = (payload) => ({
  type: EDIT_CARE_AND_USE_SUCCESS,
  payload,
});
const editCareAndUseFailure = (error) => ({
  type: EDIT_CARE_AND_USE_FAILURE,
  payload: error,
});

const editCareAndUseInstructions = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editCareAndUseRequest());
    let url = `${baseUrl}/dpp/care_and_use_instructions/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editCareAndUseSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editCareAndUseFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- DELETE API ---
const deleteCareAndUseRequest = () => ({
  type: DELETE_CARE_AND_USE_REQUEST,
});
const deleteCareAndUseSuccess = (payload) => ({
  type: DELETE_CARE_AND_USE_SUCCESS,
  payload,
});
const deleteCareAndUseFailure = (error) => ({
  type: DELETE_CARE_AND_USE_FAILURE,
  payload: error,
});

const deleteCareAndUseInstructions = (careId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteCareAndUseRequest());
    let url = `${baseUrl}/dpp/care_and_use_instructions/delete?careId=${careId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteCareAndUseSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteCareAndUseFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForCareAndUseInstructionsRequest = () => ({
  type: UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_REQUEST,
});

const uploadCsvForCareAndUseInstructionsSuccess = (payload) => ({
  type: UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_SUCCESS,
  payload: payload,
});

const uploadCsvForCareAndUseInstructionsFailure = (error) => ({
  type: UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_FAILURE,
  payload: error,
});

  const uploadCsvForCareAndUseInstructions = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForCareAndUseInstructionsRequest());
    let url = `${baseUrl}/dpp/care_and_use_instruction/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForCareAndUseInstructionsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForCareAndUseInstructionsFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createCareAndUseInstructions,
  getAllCareAndUseInstructions,
  getOneCareAndUseInstruction,
  editCareAndUseInstructions,
  deleteCareAndUseInstructions,
  uploadCsvForCareAndUseInstructions,

};